// Transaction.js (Refactored to use DataTableWithForm)
import React, { useState } from 'react';
import DataTableWithForm from '../components/DataTableWithForm';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Tooltip, IconButton
} from '@mui/material';
import { API_BASE } from '../config';
import { Visibility } from '@mui/icons-material';

const Transaction = () => {
  const [jsonDialogOpen, setJsonDialogOpen] = useState(false);
  const [selectedJson, setSelectedJson] = useState(null);

  const columns = [
    { field: 'datetime', label: 'Date', format: (val) => val?.slice(0, 19).replace('T', ' ') },
    { field: 'sessionid', label: 'Session ID' },
    { field: 'itemid_display', label: 'Item' },
    { field: 'customer_display', label: 'Customer' },
    { field: 'is_paid', label: 'Paid', format: (val) => val ? '✔' : '' },
    { field: 'is_timeout', label: 'Timeout', format: (val) => val ? '✔' : '' },
    { field: 'is_cancelled', label: 'Cancelled', format: (val) => val ? '✔' : '' },
    {
      field: 'response',
      label: 'Response',
      format: (val, row) => (
        <Tooltip title="View JSON">
          <IconButton onClick={() => handleViewJson(val)}>
            <Visibility />
          </IconButton>
        </Tooltip>
      )
    }
  ];

  const handleViewJson = (json) => {
    setSelectedJson(JSON.stringify(json, null, 2));
    setJsonDialogOpen(true);
  };

  return (
    <>
      <DataTableWithForm
        title="Transaction List"
        fetchUrl="/zts/admin/v1.0/transaction/"
        createUrl={null} // No create
        updateUrl={null} // No update
        deleteUrl={(id) => `/zts/admin/v1.0/transaction/${id}/`}
        columns={columns}
        formFields={[]} // No form
        disableCreate // Custom prop to hide Create button in DataTableWithForm
      />

      <Dialog open={jsonDialogOpen} onClose={() => setJsonDialogOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle>Transaction JSON</DialogTitle>
        <DialogContent>
          <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{selectedJson}</pre>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setJsonDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Transaction;

